import Vue from 'vue'
import { EagleModule } from 'kernel/types/module'
import {ModuleSelectorConfigType} from 'kernel/libs/moduleSelector'

class moduleIndex {
  private vm: Vue| undefined
  public name: string
  constructor() {
    this.name = 'member'
  }

  public initVue(vm: Vue) {
    this.vm = vm
  }

  async launch(vm: Vue) : Promise<void>{
    Vue.prototype.$memberSelector = (config: ModuleSelectorConfigType) => {
      vm.$moduleSelector.active(vm, {
        ...config,
        title: vm.$t('module.member'),
        bodySlot: () => import('modules/member/selector/memberList.vue'),
      })
    }
  }

  getModuleConfig() : EagleModule {
    return {
      launch: this.launch,
      menu: () => import('modules/member/config/menu'),
      realApi: () => import('modules/member/config/realApi'),
      routes: () => import('modules/member/config/route'),
    }
  }
}

export default new moduleIndex()
